import PropTypes from 'prop-types'
import React, { Component } from 'react'
import content from 'pp-react-l10n'
import glamorous from 'glamorous'
import glamorousIcon from 'lib/glamorous-icon'
import personalSvg from '../icons/svg/personal.svg'
import {
  MONEY_PAGE,
  ANALYTICS_FLOW_TYPE,
} from '../../../../../../lib/constants'
import ShieldSvg from '../icons/svg/protectionShield.svg'
import { getFlowType } from 'transfer/utils/url-utils'
import { connect } from '../../../utils/p2p-connect'
import { togglePaymentTypeChoiceOverpanel } from 'transfer/actions/unified-actions'
import ChangeTextOrIcon from '../../preview/change-text-icon'
import {
  CaptionText,
  Button,
  BodyText,
  V2SecurityPatternIcon,
  V2ShoppingcartIcon,
  V2CommunityIcon,
  v2grey600,
  Link as PPLink,
  Alert,
} from '@paypalcorp/pp-react'
import { tracking } from '../../../../lib/analytics/mParticle'
import Events from '../../../../lib/analytics/eventTags'
import enRTRStrings from '../../../../../../config/enRTRStrings'
import linksURL from '../../../../../../config/links.json'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { hasGuestFlowRevamp } from '../../../../experiments/guest'

let i18n = content('transfer/page/preview')
let i18nGuest = content('transfer/guestLogin/preview')

const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(...args))

const PaymentTypeReviewMessageContainer = glamorous.div({
  marginBottom: '16px',
})

const PaymentTypeContainer = glamorous.div({
  display: 'flex',
  padding: '0',
  justifyContent: 'space-between',
  alignItems: isDw2Repaint() || hasGuestFlowRevamp() ? 'flex-start' : 'center',
})

const PaymentTypeText = glamorous.div({
  fontSize: 15,
  lineHeight: '20px',
  color: '#2c2e2f',
  '& aside': {
    fontSize: 13,
    color: '#687173',
  },
  '& .ppvx_icon-cart': {
    fontSize: '1.3rem',
    float: 'left',
    margin: '1px 0 0 0',
    color: '#0070BA',
    display: 'inline-block',
  },
  '& .textWrapper': {
    textAlign: 'left',
    float: 'left',
  },
})

const PaymentTypeToggleText = glamorous.div({
  display: 'inline-flex',
  textAlign: 'left',
})

const PaymentTypeToggleTextWrapper = glamorous.div({
  display: 'inline-block',
})

const PaymentTypeSubTextRTR = glamorous.div({ color: v2grey600 })

const PaymentTypeToggleHelperTextContainer = glamorous.div({
  textAlign: 'left',
  margin: '0 0 1rem 0',
})

const PaymentTypeToggleHelperText = glamorous.div({
  display: 'inline',
})

const PaymentTypeToggleHelperTextEnRtr = glamorous.span({
  margin: '0.25rem 0',
  color: v2grey600,
})

const ToggleButton = ({ style, ...props }: { style: Object }) => (
  <PPLink
    as="button"
    style={{ border: 'none', background: 'none', padding: '0', ...style }}
    {...props}
  />
)

const IconContainer = glamorous.span(
  {
    float: 'left',
    margin:
      isDw2Repaint() || hasGuestFlowRevamp() ? '1px 5px 0 0' : '-2px 5px 0 0',
  },
  ({ showENSubTextRTR }) => {
    if (showENSubTextRTR) {
      return {
        margin: '1px 5px 0 0',
      }
    }
  }
)

const IconSVG = glamorousIcon({
  flex: '1 1 auto',
  width: 20,
  '& svg': { fill: '#0070BA', height: '20', width: '20' },
})

const ShieldIconSVG = glamorousIcon({
  flex: '1 1 auto',
  width: 20,
  '& svg': { fill: '#0070BA', height: '20', width: '20' },
})

ShieldIconSVG.defaultProps = { svg: ShieldSvg }

IconSVG.defaultProps = { svg: personalSvg }

const PaymentTypeDiv = glamorous.div(
  {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  ({ hideChangeButton, isPSAEnabled, isGoodServiceOnlyText }) => ({
    borderTop:
      isDw2Repaint() || hasGuestFlowRevamp() ? 'none' : '1px solid #dedede',
    padding: '16px 0',
    alignItems:
      hideChangeButton &&
      !isPSAEnabled &&
      !isGoodServiceOnlyText &&
      !isDw2Repaint() &&
      !hasGuestFlowRevamp()
        ? 'center'
        : '',
  })
)

const STYLES = {
  rtrSubText: {
    fontSize: '14px',
    color: '#687173',
    lineHeight: '20px',
  },
}

const protectionTreatment = [
  // list of variants which are in 'protection' treatment
  MONEY_PAGE.PANEL_TRUST_WEB, // t3
  MONEY_PAGE.TWO_BUTTON_REC_DEFAULT_WEB, // t9
  MONEY_PAGE.BUYER_FEES_REC_DEFAULT_WEB, // t10
  MONEY_PAGE.TWO_BUTTON_NON_DEFAULT_WEB, // t11
]

const hideFeeText = [
  // for some variant we need to hide 'fee' amount
  MONEY_PAGE.PANEL_TRUST_WEB, // t3
]

export class PaymentTypeIcon extends React.Component {
  static propTypes = {
    flowType: PropTypes.string.isRequired,
    isInProtectionTrmt: PropTypes.bool.isRequired,
    showENSubTextRTR: PropTypes.bool,
    isPSAEnabled: PropTypes.bool,
  }

  render() {
    let iconMarkup = ''
    if (this.props.isPSAEnabled) {
      return iconMarkup
    }
    if (this.props.isInProtectionTrmt) {
      iconMarkup = (
        <IconContainer showENSubTextRTR={this.props.showENSubTextRTR}>
          {this.props.flowType === 'send' ? (
            <>
              {isDw2Repaint() || hasGuestFlowRevamp() ? (
                <V2CommunityIcon size="sm" />
              ) : (
                <IconSVG />
              )}
            </>
          ) : (
            <>
              {isDw2Repaint() || hasGuestFlowRevamp() ? (
                <V2ShoppingcartIcon size="sm" />
              ) : (
                <span className="ppvx_icon ppvx_icon--size_xl2 ppvx_icon-cart"></span>
              )}
            </>
          )}
        </IconContainer>
      )
    } else {
      iconMarkup =
        // eslint-disable-next-line no-nested-ternary
        this.props.flowType === 'buy' ? (
          isDw2Repaint() || hasGuestFlowRevamp() ? (
            <IconContainer showENSubTextRTR={this.props.showENSubTextRTR}>
              <V2SecurityPatternIcon size="sm" />
            </IconContainer>
          ) : (
            <IconContainer showENSubTextRTR={this.props.showENSubTextRTR}>
              <ShieldIconSVG />
            </IconContainer>
          )
        ) : isDw2Repaint() || hasGuestFlowRevamp() ? (
          <></>
        ) : (
          <IconContainer showENSubTextRTR={this.props.showENSubTextRTR}>
            <></>
          </IconContainer>
        )
    }
    return iconMarkup
  }
}

export class PaymentTypeToggle extends Component {
  static propTypes = {
    flowType: PropTypes.string.isRequired,
    hideChangeButton: PropTypes.bool,
    openOverpanel: PropTypes.func.isRequired,
    styles: PropTypes.object,
    css: PropTypes.object,
    onToggle: PropTypes.func,
    overpanelType: PropTypes.string,
    totalReceiverFee: PropTypes.string,
    whoPaysFee: PropTypes.string,
    showENSubTextRTR: PropTypes.bool,
    isPSAEnabled: PropTypes.bool,
    isGoodServiceOnlyText: PropTypes.bool,
    paymentTypeToggleSendHelperText: PropTypes.string,
    paymentTypeToggleBuyHelperText: PropTypes.string,
    paymentTypeReviewMessage: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.isInProtectionTrmt = protectionTreatment.includes(
      this.props.overpanelType
    )
    this.noFeeOnReviewVariants =
      protectionTreatment && hideFeeText.includes(this.props.overpanelType)
  }

  render() {
    const { paymentTypeReviewMessage } = this.props

    // if we don't know flow type, we can't really show anything
    if (!this.props.flowType) {
      return null
    }
    const { hideChangeButton, showENSubTextRTR = false } = this.props
    const contentMap = {
      send: 'unified.paymentTypeToggle.send',
      buy:
        this.props.isPSAEnabled || this.props.isGoodServiceOnlyText
          ? 'unified.paymentTypeToggle.buyGoodsOnly'
          : 'unified.paymentTypeToggle.buy',
    }
    const changeText = i18n('unified.paymentTypeToggle.change')

    const contentMapTreatment = {
      send: 'unified.paymentTypeToggle.personal',
      buy: 'unified.paymentTypeToggle.protection',
    }

    const paymentTypeToggleHelperTextRTR = {
      send: 'unified.paymentTypeToggleSendHelperText',
      buy: 'unified.paymentTypeToggleBuyHelperText',
    }

    const paymentTypeToggleHelperTextProps = {
      send: this.props.paymentTypeToggleSendHelperText,
      buy: this.props.paymentTypeToggleBuyHelperText,
    }

    let sideNote = null
    if (this.props.flowType === 'buy' && this.isInProtectionTrmt) {
      if (this.props.whoPaysFee === 'sellerPaysFee') {
        if (!this.props.totalReceiverFee && !this.noFeeOnReviewVariants) {
          sideNote = i18nGuest('info.sellerPaysFee')
          // we didn't get totalReceiverFee, so let's track it
          tracking(
            Events.p2p_non_visible_error_occurred({
              description: 'review_screen_no_total_receiver_fees_returned',
              file_name: 'payment-type-toggle',
              function_name: 'render',
            })
          )
        } else {
          sideNote = i18n('unified.paymentTypeToggle.buySellerPays', {
            protectionFee: this.props.totalReceiverFee,
          })
        }
      } else if (this.props.whoPaysFee === 'senderPaysFee') {
        sideNote = i18n('unified.paymentTypeToggle.buySenderPays')
      }
    }

    return (
      <>
        <PaymentTypeDiv
          css={this.props.css}
          hideChangeButton={hideChangeButton}
          isPSAEnabled={this.props.isPSAEnabled}
          isGoodServiceOnlyText={this.props.isGoodServiceOnlyText}
        >
          {paymentTypeReviewMessage && (
            <PaymentTypeReviewMessageContainer>
              <Alert
                type="warning"
                typeIconAriaLabel={i18n('paymentTypeReviewMessage.iconLabel')}
              >
                {paymentTypeReviewMessage}
              </Alert>
            </PaymentTypeReviewMessageContainer>
          )}
          <PaymentTypeContainer>
            {isDw2Repaint() || hasGuestFlowRevamp() ? (
              <>
                <PaymentTypeToggleText>
                  <PaymentTypeIcon
                    flowType={this.props.flowType}
                    isInProtectionTrmt={this.isInProtectionTrmt}
                    showENSubTextRTR={showENSubTextRTR}
                    isPSAEnabled={this.props.isPSAEnabled}
                  />
                  <PaymentTypeToggleTextWrapper>
                    <BodyText data-nemo="payment-type">
                      {this.isInProtectionTrmt
                        ? i18n(contentMapTreatment[this.props.flowType])
                        : i18n(contentMap[this.props.flowType])}
                    </BodyText>
                    {showENSubTextRTR && (
                      <CaptionText as={PaymentTypeSubTextRTR}>
                        {this.isInProtectionTrmt
                          ? enRTRStrings[
                              contentMapTreatment[this.props.flowType]
                            ]
                          : enRTRStrings[contentMap[this.props.flowType]]}
                      </CaptionText>
                    )}
                    {!this.noFeeOnReviewVariants && sideNote && (
                      <CaptionText>{sideNote}</CaptionText>
                    )}
                  </PaymentTypeToggleTextWrapper>
                </PaymentTypeToggleText>
                {hideChangeButton || (
                  <Button
                    tertiary={true}
                    type="button"
                    style={{ padding: 0 }}
                    name="ChangePmtType"
                    tabIndex="0"
                    onClick={callAll(
                      this.props.openOverpanel,
                      this.props.onToggle
                    )}
                    data-test="toggle-button"
                    data-nemo="toggle-button"
                    /* TODO: Will need to use something better for ARIA only for this design */
                    // eslint-disable-next-line i18n-scan/no-inline-concatenation
                    aria-label={`${changeText} ${i18n(
                      contentMap[this.props.flowType]
                    )}`}
                    regular
                  >
                    {changeText}
                  </Button>
                )}
              </>
            ) : (
              <>
                <PaymentTypeText className="ppvx_text--md">
                  <PaymentTypeIcon
                    flowType={this.props.flowType}
                    isInProtectionTrmt={this.isInProtectionTrmt}
                    showENSubTextRTR={showENSubTextRTR}
                    isPSAEnabled={this.props.isPSAEnabled}
                  />
                  <div className="textWrapper">
                    <span data-nemo="payment-type">
                      {this.isInProtectionTrmt
                        ? i18n(contentMapTreatment[this.props.flowType])
                        : i18n(contentMap[this.props.flowType])}
                    </span>
                    {showENSubTextRTR && (
                      <div style={STYLES.rtrSubText}>
                        {this.isInProtectionTrmt
                          ? enRTRStrings[
                              contentMapTreatment[this.props.flowType]
                            ]
                          : enRTRStrings[contentMap[this.props.flowType]]}
                      </div>
                    )}
                    {!this.noFeeOnReviewVariants && sideNote && (
                      <aside>{sideNote}</aside>
                    )}
                  </div>
                </PaymentTypeText>
                {hideChangeButton || (
                  <ToggleButton
                    name="ChangePmtType"
                    type="button"
                    tabIndex="0"
                    onClick={callAll(
                      this.props.openOverpanel,
                      this.props.onToggle
                    )}
                    data-test="toggle-button"
                    data-nemo="toggle-button"
                    /* TODO: Will need to use something better for ARIA only for this design */
                    // eslint-disable-next-line i18n-scan/no-inline-concatenation
                    aria-label={`${changeText} ${i18n(
                      contentMap[this.props.flowType]
                    )}`}
                    regular
                  >
                    <ChangeTextOrIcon text={changeText} />
                  </ToggleButton>
                )}
              </>
            )}
          </PaymentTypeContainer>
        </PaymentTypeDiv>
        {paymentTypeToggleHelperTextProps[this.props.flowType] && (
          <PaymentTypeToggleHelperTextContainer data-nemo="payment-type-toggle-protection">
            <CaptionText as={PaymentTypeToggleHelperText}>
              {paymentTypeToggleHelperTextProps[this.props.flowType]}{' '}
            </CaptionText>
            <PPLink
              size="sm"
              href={linksURL.ALL.PURCHASE_PROTECTION_URL}
              target="_blank"
              onClick={() =>
                tracking(Events.p2p_review_payment_type_terms_pressed())
              }
            >
              {i18n('shield.paymentTypeTogglePurchaseProtection')}
            </PPLink>
            {showENSubTextRTR && (
              <div>
                <CaptionText as={PaymentTypeToggleHelperTextEnRtr}>
                  {
                    enRTRStrings[
                      paymentTypeToggleHelperTextRTR[this.props.flowType]
                    ]
                  }{' '}
                </CaptionText>
                <PPLink
                  size="sm"
                  href={linksURL.ALL.PURCHASE_PROTECTION_URL}
                  target="_blank"
                >
                  {enRTRStrings['shield.paymentTypeTogglePurchaseProtection']}
                </PPLink>
              </div>
            )}
          </PaymentTypeToggleHelperTextContainer>
        )}
      </>
    )
  }
}

export default connect(
  ({ server, external, recipient, amount, transaction }) => ({
    hideChangeButton:
      recipient.isHardDefault ||
      !server.isFFEligible ||
      recipient.isGSOnlyRecipient ||
      !!(server.env === 'pisp' && !external.paymentTypeEditable) ||
      server.env === ANALYTICS_FLOW_TYPE.PPSHOPS,
    flowType: getFlowType(),
    overpanelType: recipient.moneyPageOverPanel || [],
    whoPaysFee: transaction.whoPaysFee,
    isPSAEnabled: server.isPSAEnabled,
    isGoodServiceOnlyText: recipient.isGSOnlyRecipient,
    paymentTypeToggleSendHelperText: recipient.paymentTypeTogglePersonalMessage,
    paymentTypeToggleBuyHelperText: recipient.paymentTypeTogglePurchaseMessage,
    paymentTypeReviewMessage: transaction.paymentTypeReviewMessage,
  }),
  dispatch => ({
    openOverpanel: () => {
      dispatch(togglePaymentTypeChoiceOverpanel({ show: true }))
    },
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  })
)(PaymentTypeToggle)
